export const getFormattedCost = (currency: string, price?: number): string => {
    if (currency && price) {
        const formattedCost = Intl.NumberFormat('en-US', { style: 'currency', currency });
        return price ? formattedCost.format(price) : 'N/A';
    }
    return '';
};

export default getFormattedCost;
